/**
 * Directory scraper API (internal /scrapper page). Uses ApiResponse-unwrapped axios responses.
 */
import api from './api/axiosConfig';

export async function searchDirectory(payload) {
  const res = await api.post('/directory-scraper/search/', payload);
  return res.data;
}

/** Supplemental fetch (extra query variants) for an existing session — last-page “fetch more”. */
export async function fetchMoreFromDirectory(sessionId) {
  const res = await api.post('/directory-scraper/extend/', { session_id: sessionId });
  return res.data;
}

export async function fetchListings(sessionId, { sort, userLat, userLng, page, pageSize } = {}) {
  const params = {
    session_id: sessionId,
    sort: sort || 'name_asc',
    page: page ?? 1,
    page_size: pageSize ?? 20,
  };
  if (userLat != null && userLng != null) {
    params.user_lat = userLat;
    params.user_lng = userLng;
  }
  const res = await api.get('/directory-scraper/listings/', { params });
  return res.data;
}

export async function fetchCities() {
  const res = await api.get('/directory-scraper/meta/cities/');
  return res.data.cities || [];
}

export async function fetchAreas(city) {
  if (!city) return [];
  const res = await api.get('/directory-scraper/meta/areas/', { params: { city } });
  return res.data.areas || [];
}

/**
 * Download PDF or Excel; uses blob response (not JSON envelope).
 */
export async function downloadExport(sessionId, exportFormat, sort, userLat, userLng) {
  const params = {
    session_id: sessionId,
    export_format: exportFormat,
    sort: sort || 'name_asc',
  };
  if (userLat != null && userLng != null) {
    params.user_lat = userLat;
    params.user_lng = userLng;
  }
  const res = await api.get('/directory-scraper/export/', {
    params,
    responseType: 'blob',
  });
  const blob = res.data;
  const disposition = res.headers['content-disposition'] || '';
  let filename = exportFormat === 'pdf' ? 'export.pdf' : 'export.xlsx';
  const m = /filename="([^"]+)"/.exec(disposition);
  if (m) filename = m[1];
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
